<!--begin::Signin-->
<div class="login-form login-signin pt-1">
    <!--begin::Form-->
    <form class="form" [formGroup]="loginForm" novalidate="novalidate" id="kt_login_signin_form" (ngSubmit)="tryLogin()" #localForm>
       <!--begin::Title-->
       <div class="pb-13 pt-lg-0 pt-5">
          <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"></h3>
       </div>
       <ng-container *ngIf="hasError">
          <div class="mb-10 alert alert-custom alert-light-danger alert-dismissible">
             <div class="alert-text">{{ loginErrorMessage }}</div>
          </div>
       </ng-container>
       <div class="form-group">
          <label class="font-size-h6 font-weight-bolder text-dark login-label">Email</label>
          <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg" type="email" readonly="true" name="email" formControlName="email" autocomplete="off" [ngClass]="{ 'is-invalid': loginForm.controls['email'].invalid && loginForm.controls['email'].touched }" />
          <ng-container
             [ngTemplateOutlet]="formError"
             [ngTemplateOutletContext]="{
                validation: 'required',
                message: 'Campo Requerido',
                control: loginForm.controls['email']
             }"
          ></ng-container>
          <ng-container
             [ngTemplateOutlet]="formError"
             [ngTemplateOutletContext]="{
                validation: 'pattern',
                message: 'Ingrese un email válido',
                control: loginForm.controls['email']
             }"
          ></ng-container>
          <ng-container
             [ngTemplateOutlet]="formError"
             [ngTemplateOutletContext]="{
                validation: 'minLength',
                message: 'El email debe contener 3 carácteres como mínimo',
                control: loginForm.controls['email']
             }"
          ></ng-container>
          <ng-container
             [ngTemplateOutlet]="formError"
             [ngTemplateOutletContext]="{
                validation: 'maxLength',
                message: 'El email puede contener 320 carácteres como máximo',
                control: loginForm.controls['email']
             }"
          ></ng-container>
       </div>
       <!--end::Form group-->
 
       <!--begin::Form group-->
       <div class="form-group">
          <div class="d-flex justify-content-between mt-n5">
             <label class="font-size-h6 font-weight-bolder text-dark pt-5 login-label">Contraseña</label>
             <!-- <a
           routerLink="/auth/forgot-password"
           class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5"
           id="kt_login_forgot"
         > -->
          </div>
          <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg" readonly="true" type="password" name="password" autocomplete="off" formControlName="password" [ngClass]="{ 'is-invalid': loginForm.controls['password'].invalid && loginForm.controls['password'].touched }" />
          <ng-container
             [ngTemplateOutlet]="formError"
             [ngTemplateOutletContext]="{
                validation: 'required',
                message: 'Campo requerido',
                control: loginForm.controls['password']
             }"
          ></ng-container>
       </div>
       <!--end::Form group-->
 
       <!--begin::Action-->
       <div class="pb-lg-0 pb-5">
          <button type="submit" id="kt_login_signin_submit" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3" [disabled]="loginForm.invalid">
             <span class="fas fa-sign-in-alt mr-2"></span>
             Ingresar
          </button>
          <ng-container *ngIf="combinedObs$ | async">
             <span class="spinner spinner-primary ml-5"></span>
          </ng-container>
       </div>
       <!--end::Action-->
    </form>
 </div>
 <!--end::Signin-->
 <div class="alert alert-custom alert-white alert-shadow fade show gutter-b" role="alert">
    <div class="alert-icon">
       <span class="svg-icon svg-icon-primary svg-icon-xl">
          <svg viewBox="-32 0 511 511.9949" xmlns="http://www.w3.org/2000/svg">
             <path
                d="m143.921875 106.464844-53.203125-7.285156c-16.472656-2.253907-31.660156 9.273437-33.917969 25.75l-20.957031 153.066406 10.398438 94.113281-43.71875 100.328125c-5.347657 12.269531.261718 26.550781 12.53125 31.898438 12.308593 5.363281 26.570312-.308594 31.898437-12.535157l46.277344-106.191406c1.679687-3.847656 2.328125-8.0625 1.886719-12.234375l-9.371094-88.546875 62.96875 8.621094 20.957031-153.066407c2.253906-16.476562-9.273437-31.660156-25.75-33.917968zm0 0"
                fill="#5f6e9b"
             />
             <path d="m119.054688 488.949219-5.660157-115.21875-17.269531-100.066407c-2.277344-13.191406 6.570312-25.726562 19.757812-28.003906s25.726563 6.570313 28.003907 19.757813l17.519531 101.523437c.167969.972656.277344 1.949219.324219 2.933594l5.734375 116.695312c.660156 13.367188-9.644532 24.738282-23.015625 25.394532-13.363281.660156-24.734375-9.648438-25.394531-23.015625zm0 0" fill="#414b82" />
             <path d="m309.253906 511.925781c-13.367187-.65625-23.675781-12.027343-23.015625-25.394531l5.734375-116.695312c.046875-.980469.15625-1.960938.324219-2.929688l17.519531-101.523438c2.277344-13.191406 14.816406-22.035156 28.003906-19.757812 13.1875 2.273438 22.035157 14.8125 19.757813 28l-17.269531 100.066406-5.660156 115.21875c-.65625 13.367188-12.027344 23.675782-25.394532 23.015625zm0 0" fill="#748488" />
             <path d="m375.382812 491.609375-17.480468-108.496094c-.339844-2.117187-.398438-4.269531-.171875-6.402343l10.488281-99.132813c1.40625-13.308594 13.328125-22.960937 26.648438-21.550781 13.3125 1.410156 22.957031 13.339844 21.550781 26.648437l-10.148438 95.917969 16.964844 105.308594c2.128906 13.210937-6.859375 25.652344-20.070313 27.78125-13.25 2.132812-25.65625-6.886719-27.78125-20.074219zm0 0" fill="#55696e" />
             <path d="m241.507812 263.523438 78.097657-20.28125c6.546875-1.699219 11.804687-6.5625 14.011719-12.953126l32.097656-92.96875c3.640625-10.546874-1.957032-22.042968-12.5-25.683593-10.539063-3.644531-22.039063 1.957031-25.679688 12.5l-28.5625 82.734375-67.617187 17.5625c-10.792969 2.800781-17.273438 13.824218-14.46875 24.621094 2.800781 10.78125 13.816406 17.277343 24.621093 14.46875zm0 0" fill="#ba6746" />
             <path d="m148.714844 293.449219-112.871094-15.453125 20.957031-153.066406c2.257813-16.476563 17.445313-28.003907 33.917969-25.746094l53.203125 7.28125c16.476563 2.257812 28.003906 17.441406 25.75 33.917968zm0 0" fill="#64afff" />
             <path d="m193.886719 44.574219c0 24.617187-19.957031 44.574219-44.574219 44.574219s-44.574219-19.957032-44.574219-44.574219c0-24.617188 19.957031-44.574219 44.574219-44.574219s44.574219 19.957031 44.574219 44.574219zm0 0" fill="#ffb69e" />
             <path d="m213.328125 269.558594-78.09375-20.28125c-6.546875-1.703125-11.804687-6.5625-14.015625-12.957032l-32.09375-92.96875c-3.640625-10.542968 1.957031-22.039062 12.5-25.679687 10.539062-3.648437 22.039062 1.957031 25.679688 12.5l28.5625 82.730469 67.613281 17.5625c10.796875 2.804687 17.277343 13.828125 14.472656 24.621094-2.800781 10.78125-13.820313 17.277343-24.625 14.472656zm0 0" fill="#ffb69e" />
             <path d="m304.972656 293.449219 112.867188-15.453125-20.957032-153.066406c-2.253906-16.476563-17.441406-28.003907-33.917968-25.746094l-53.199219 7.28125c-16.476563 2.257812-28.003906 17.441406-25.75 33.917968zm0 0" fill="#ffda52" />
             <path d="m348.949219 44.574219c0 24.617187-19.957031 44.574219-44.578125 44.574219-24.617188 0-44.574219-19.957032-44.574219-44.574219 0-24.617188 19.957031-44.574219 44.574219-44.574219 24.621094 0 44.578125 19.957031 44.578125 44.574219zm0 0" fill="#ba6746" />
             <path d="m444.703125 269.089844 2.222656-80.652344c.1875-6.761719-3.023437-13.167969-8.550781-17.0625l-80.386719-56.671875c-9.117187-6.425781-21.714843-4.246094-28.144531 4.871094-6.429688 9.113281-4.246094 21.714843 4.871094 28.144531l71.535156 50.429688-1.921875 69.832031c-.304687 11.148437 8.484375 20.433593 19.632813 20.742187 11.132812.304688 20.4375-8.472656 20.742187-19.632812zm0 0" fill="#ba6746" />
             <path d="m105.3125 190.242188 37.546875-15.015626-15.554687-45.058593c-3.640626-10.542969-15.140626-16.144531-25.679688-12.5-10.542969 3.640625-16.140625 15.140625-12.5 25.683593zm0 0" fill="#4699f2" />
             <path d="m395.59375 141.214844-37.605469-26.511719c-9.117187-6.425781-21.71875-4.246094-28.144531 4.871094-6.433594 9.113281-4.246094 21.714843 4.871094 28.140625l39.023437 27.511718zm0 0" fill="#ffc305" />
          </svg>
          <!--begin::Svg Icon | path:assets/media/svg/icons/Tools/Compass.svg-->
          <!--end::Svg Icon-->
       </span>
    </div>
    <div class="alert-text">Bienvenido al Demo de <strong>SimpleFactura</strong>. En la empresa demo podrás emitir documentos y estos serán enviados al SII en el ambiente de certificación/pruebas. <span style="color: red">La empresa es real</span>. Podrás revisar el proceso de emisión, los mantenedores y configuración general.</div>
 </div>
 
 <ng-template #formError let-control="control" let-message="message" let-validation="validation">
    <ng-container *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
       <div class="fv-plugins-message-container">
          <div class="fv-help-block">
             {{ message }}
          </div>
       </div>
    </ng-container>
 </ng-template>
 